function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.573 12.097l-.462.46.114.643.684 3.863-3.182-1.829-.623-.359-.623.359-3.182 1.829.684-3.863.115-.643-.462-.46-2.77-2.765 3.719-.51.686-.095.284-.63 1.549-3.442 1.55 3.442.284.63.685.095 3.72.51-2.77 2.765zm4.064-3.848l-4.843-.666-2.066-4.586a.676.676 0 00-.624-.404.676.676 0 00-.624.404L7.415 7.583l-4.844.666a.688.688 0 00-.39 1.168l3.572 3.565-.895 5.051a.688.688 0 00.675.81.68.68 0 00.34-.093l4.231-2.432 4.232 2.432c.11.064.227.093.34.093a.688.688 0 00.675-.81l-.895-5.052 3.57-3.564a.688.688 0 00-.39-1.168z",
    fill: props.color
  }));
}

export default SvgIconStarOutline;